import React, { useState } from 'react';

import StockMobileSidePanel from '@/components/StockMobileSidePanel';
import { OptionType } from '@/typings/common';
import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  getStockFilterParams,
  setCarBodies,
  setPage,
} from '@/store/reducers/cars-stock';
import {
  getBodyOptions,
  handleChangeMultiSelect,
} from '@/modules/CarsStock/components/common.helpers';
import StockFilterMultiSelect from '@/components/StockFilterMultiSelect';

import {
  FilterButton,
  FilterButtonWrapper,
  MobileFilterItemWrapper,
} from '../../../../../../../common.styles';

function BodyFilter() {
  const dispatch = useTypedDispatch();
  const stockFilterParams = useTypedSelector(getStockFilterParams);
  const selectedBodies =
    useTypedSelector(getSelectedFilters).selectedParams.selectedBodies;
  const [isOpened, setOpened] = useState(false);

  const handleSidePanelOpen = () => {
    setOpened(true);
  };

  const handleSidePanelClose = () => {
    setOpened(false);
  };

  const bodyOptions = getBodyOptions(stockFilterParams);

  const handleChangeBody = (body: OptionType) => {
    dispatch(setCarBodies(handleChangeMultiSelect(body, selectedBodies)));
    dispatch(setPage(1));
  };

  const handleClearBody = () => {
    dispatch(setCarBodies([]));
    dispatch(setPage(1));
  };

  return (
    <StockMobileSidePanel
      title="Тип кузова"
      zIndex={10001}
      isInnerSidePanel
      isOpened={isOpened}
      onOpen={handleSidePanelOpen}
      onClose={handleSidePanelClose}
    >
      <MobileFilterItemWrapper>
        <StockFilterMultiSelect
          options={bodyOptions}
          selectedOptions={selectedBodies}
          onChange={handleChangeBody}
          onClear={handleClearBody}
        />
      </MobileFilterItemWrapper>

      <FilterButtonWrapper>
        <FilterButton onClick={handleSidePanelClose}>Применить</FilterButton>
      </FilterButtonWrapper>
    </StockMobileSidePanel>
  );
}

export default BodyFilter;
